import React, { useState } from 'react';
import { Star } from 'lucide-react';

export default function StarRating({ value, onChange, disabled = false, size = 16 }) {
  const [hoverValue, setHoverValue] = useState(null);

  const handleClick = (rating) => {
    if (!disabled && onChange) {
      onChange(rating);
    }
  };

  const getStarColor = (starIndex) => {
    const currentValue = hoverValue !== null ? hoverValue : value;
    
    if (currentValue >= starIndex) {
      return 'text-yellow-500 fill-yellow-500';
    }
    return 'text-gray-300';
  };

  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((starIndex) => (
        <button
          key={starIndex}
          type="button"
          onClick={() => handleClick(starIndex)}
          onMouseEnter={() => !disabled && setHoverValue(starIndex)}
          onMouseLeave={() => !disabled && setHoverValue(null)}
          disabled={disabled}
          className={`transition-colors ${disabled ? 'cursor-default' : 'cursor-pointer hover:scale-110'}`}
          aria-label={`Rate ${starIndex} star${starIndex > 1 ? 's' : ''}`}
        >
          <Star 
            size={size} 
            className={`transition-all ${getStarColor(starIndex)}`}
          />
        </button>
      ))}
    </div>
  );
}
